import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "../../pages/api/axios";

//Import Icons
import FeatherIcon from "feather-icons-react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import jwt_decode from "jwt-decode";
import car from "../../assets/images/car1.png";

const SidebarContent = (props) => {
  const [dashboarddata, setDashboardData] = useState("");
  const [residentApplicationInfo, setResidentApplicationInfo] = useState({
    Total: 0,
    Pending: 0,
    Approved: 0,
    Denied: 0,
  });
  const [viewLeadsInfo, setViewLeadsInfo] = useState({
    total: 0,
    closed: 0,
    pending: 0,
    cancelled: 0,
    follow_up: 0,
  });
  const [appointmentsInfo, setAppointmentsInfo] = useState({
    total: 0,
    booked: 0,
    rejected: 0,
    rejected: 0,
  });
  const [maintenanceRequestInfo, setMaintenanceRequestInfo] = useState({
    total: 0,
    open: 0,
    inprogress: 0,
    completed: 0,
    unresolved: 0,
  });

  const decode = jwt_decode(window.localStorage.getItem("accessToken"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Request 1: Fetch navdata
        const navdataResponse = await axios.post(
          "/navdata/maintenancerequests",
          {
            companyDomain: decode.domain,
            managerID: decode.id,
          }
        );
        // Handle navdataResponse as needed

        // Request 2: Fetch resident applications
        const residentApplicationsResponse = await axios.post(
          "/navdata/residentapplications?page=1&limit=10",
          {
            role: decode.role,
            domain: decode.domain,
          }
        );

        // Handle residentApplicationsResponse as needed

        // Request 3: Fetch pending slots
        const pendingSlotsResponse = await axios.post(
          "/user_appointment/get-pending-slot",
          {
            manager_id: decode.id,
          }
        );
        // Update the state with fetched data
        setDashboardData({
          maintenanceTickets: navdataResponse.data?.openTicketsCount,
          residentApplications:
            residentApplicationsResponse.data.total?.Pending || 0,
          pendingSlots: pendingSlotsResponse.data,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // * Get Manager Pending slots start

  const getApplicants = async (url, data) => {
    try {
      const response = await axios.post(url, data);
      if (response.status === 200) {
        if (response.data.results.applications) {
          const temp = response.data.results.applications;
          setResidentApplicationInfo((prev) => ({
            ...prev,
            Total: response.data.total.Total || 0,
            Pending: response.data.total.Pending || 0,
            Approved: response.data.total.Approved || 0,
            Denied: response.data.total.Denied || 0,
          }));
        }
      } else {
        console.warn("Unable to fetch the resources");
      }
    } catch (error) {
      console.error("Unable to get applicants", error);
    }
  };

  const getLeads = async (e) => {
    try {
      const response = await axios.get(
        `/leads/getLeadsManager?page=1&limit=10`
      );

      if (response.data?.success && response?.data?.leads?.length > 0) {
        setViewLeadsInfo((prev) => ({
          ...prev,
          total: response.data.total.Total || 0,
          pending: response.data.total.Pending || 0,
          closed: response.data.total.Closed || 0,
          cancelled: response.data.total.Cancelled || 0,
          follow_up: response.data.total["Follow Up"] || 0,
        }));
      }
    } catch (error) {
      console.error("Error", error); // TODO proper error
    }
  };

  const searchTicket = async (decode) => {
    try {
      let query = {};
      let response;
      if (decode.role == "manager") {
        query = {
          managerID: decode.id,
        };

        response = await axios.post("/ticket/filter_tickets_manager", query);
      }
      if (response?.status === 200) {
        setMaintenanceRequestInfo((prev) => ({
          ...prev,
          total: response.data.total?.Total || 0,
          open: response.data.total?.Open || 0,
          completed: response.data.total?.Completed || 0,
          inprogress: response.data.total?.Inprogress || 0,
          unresolved: response.data.total?.Unresolved || 0,
        }));
      }
    } catch (error) {
      console.error(error); // TODO proper error
    }
  };

  const getAppointments = async (decode) => {
    let query = {
      manager_id: decode.id,
    };

    let res = await axios.post(
      "/user_appointment/get-pending-slot",
      JSON.stringify(query),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = res.data;
    setAppointmentsInfo((prev) => ({
      ...prev,
      total: data?.total?.Total || 0,
      booked: data?.total?.booked || 0,
      pending: data?.total?.pending || 0,
      rejected: data?.total?.rejected || 0,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      const decode = jwt_decode(window.localStorage.getItem("accessToken"));

      await getApplicants(`/applicant/list?page=1&limit=10`, {
        role: decode.role,
        managerID: decode.id,
      });

      await getLeads();
      await searchTicket(decode);
      await getAppointments(decode);
    };

    fetchData();
  }, []);

  // * Get Manager Pending slots end

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  if (window.localStorage.getItem("accessToken")) {
    // Checking for the token for expire
    const decode = jwt_decode(window.localStorage.getItem("accessToken"));
    const expDate = new Date(decode.exp * 1000);
    if (Date.now() > expDate) {
      // remove old localstorage data
      window.localStorage.removeItem("role");
      window.localStorage.removeItem("accessToken");
      // redirect to login
      window.location.replace("/login");
    }

    const role = window.localStorage.getItem("role");
    const user =
      JSON.parse(window.localStorage.getItem("authUser"))?.userData?.company ||
      "GSK";
    if (role === "admin") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li className="facilities-li">
                  <Link to="/company" className="">
                    <FeatherIcon icon="briefcase" />
                    <span>{props.t("Companies")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="briefcase" />
                    <span>{props.t("RDCare Leads")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/viewRentdigiLeads">
                        {props.t("View Leads")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("RDCare Blogs")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/addblog">{props.t("Add Blogs")}</Link>
                    </li>
                    <li>
                      <Link to="/blog">{props.t("Blog List")}</Link>
                    </li>
                    <li>
                      <Link to="/editblog">{props.t("Edit Blog")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("RDCare Newsletters")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/newsletters">
                        {props.t("View Newsletters")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/vendor-specialty">
                        {props.t("Vendor Speciality")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="facilities-li">
                  <a
                    target="_blank"
                    href="http://sms.rentdigicare.com/admin"
                    className=""
                    rel="noreferrer"
                  >
                    <FeatherIcon icon="message-square" />
                    <span>{props.t("RDCare SMS")}</span>
                  </a>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "company") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/dashboard" className="">
                    <FeatherIcon icon="grid" />
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>

                <li className="facilities-li">
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="home" />
                    <span>{props.t("Properties")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/property_layout">
                        {props.t("Property Layout")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/property">{props.t("Property")}</Link>
                    </li>
                    <li>
                      <Link to="/property_manager">
                        {props.t("Property Manager")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/Accountant">{props.t("Accountant")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="calendar" />
                    <span>{props.t("Calendar")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/calendar_reasons">
                        {props.t("Reason Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/calender_availabilty">
                        {props.t("Availability")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/appointments">
                        {props.t("Approve Appointments")}
                        {dashboarddata.pendingSlots
                          ? ` ( ${dashboarddata.pendingSlots.total.pending ?? 0
                          } Pending )`
                          : null}
                      </Link>
                    </li>
                    <li>
                      <Link to="/apps-calendar">
                        {props.t("Calendar View")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/calendar-appointment-status">
                        {props.t("Calendar Status Types")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Maintenance Request")} </span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/tickets_list">
                        {props.t("View Request")}
                        {dashboarddata.maintenanceTickets
                          ? ` ( ${dashboarddata.maintenanceTickets} Open )`
                          : null}
                      </Link>
                    </li>
                    <li>
                      <Link to="/request_type">{props.t("Request Types")}</Link>
                    </li>
                    <li>
                      <Link to="/permissions">
                        {props.t("Entry Permissions")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/emailnotification">
                        {props.t("Email Notification")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="monitor" />
                    <span>{props.t("Maintenance Team")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/technical_staff">
                        {props.t("View Maintenance Team")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/add_specialities">
                        {props.t("Add Category")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="users" />
                    <span>{props.t("Vendors")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/vendor-specialty">
                        {props.t("Add Category")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/viewvendor">{props.t("View Vendors")}</Link>
                    </li>
                    <li>
                      <Link to="/vendors">{props.t("Approve Vendors")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="briefcase" />
                    <span>{props.t("Leads")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/viewleads">{props.t("View Leads")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.2"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.27323 4.00237C6.54965 4.17438 5.98127 4.73371 5.79768 5.45445L4.60127 10.1512C3.68774 10.336 3 11.1434 3 12.1115V15C3 15.8061 3.4769 16.5008 4.16395 16.8174C4.05913 17.0222 4 17.2542 4 17.5V18.5C4 19.3284 4.67157 20 5.5 20C6.32843 20 7 19.3284 7 18.5V17.5C7 17.3247 6.96992 17.1564 6.91465 17H16.0854C16.0301 17.1564 16 17.3247 16 17.5V18.5C16 19.3284 16.6716 20 17.5 20C18.3284 20 19 19.3284 19 18.5V17.5C19 17.2542 18.9409 17.0222 18.836 16.8174C19.5231 16.5008 20 15.8061 20 15V12.1115C20 11.1434 19.3123 10.336 18.3987 10.1512L17.2023 5.45433C17.0187 4.73367 16.4504 4.17437 15.7269 4.00229C14.3193 3.66752 12.9103 3.5 11.5007 3.5C10.0911 3.5 8.68164 3.66755 7.27323 4.00237Z" fill="currentColor" /></g><path fill-rule="evenodd" clip-rule="evenodd" d="M4.29768 3.95445L3.10127 8.65122C2.18774 8.83604 1.5 9.64344 1.5 10.6115V13.5C1.5 14.6046 2.39543 15.5 3.5 15.5L16.5 15.5C17.6046 15.5 18.5 14.6046 18.5 13.5V10.6115C18.5 9.64344 17.8123 8.83604 16.8987 8.65122L15.7023 3.95433C15.5187 3.23367 14.9504 2.67437 14.2269 2.50229C12.8193 2.16752 11.4103 2 10.0007 2C8.59105 2 7.18164 2.16755 5.77323 2.50237C5.04965 2.67438 4.48127 3.23371 4.29768 3.95445ZM3.5 9.61147C3.72861 9.61147 3.9281 9.45643 3.98453 9.2349L5.26673 4.2013C5.35853 3.84093 5.64272 3.56126 6.00452 3.47525C7.33767 3.15832 8.66949 3 10.0007 3C11.3318 3 12.6632 3.15829 13.9955 3.47515C14.3573 3.56119 14.6414 3.84085 14.7332 4.20118L16.0155 9.2349C16.0719 9.45643 16.2714 9.61147 16.5 9.61147C17.0523 9.61147 17.5 10.0592 17.5 10.6115V13.5C17.5 14.0523 17.0523 14.5 16.5 14.5H3.5C2.94772 14.5 2.5 14.0523 2.5 13.5V10.6115C2.5 10.0592 2.94772 9.61147 3.5 9.61147Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 16C5.5 15.1716 4.82843 14.5 4 14.5C3.17157 14.5 2.5 15.1716 2.5 16V17C2.5 17.8284 3.17157 18.5 4 18.5C4.82843 18.5 5.5 17.8284 5.5 17V16ZM3.5 16C3.5 15.7239 3.72386 15.5 4 15.5C4.27614 15.5 4.5 15.7239 4.5 16V17C4.5 17.2761 4.27614 17.5 4 17.5C3.72386 17.5 3.5 17.2761 3.5 17V16Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16V17C14.5 17.8284 15.1716 18.5 16 18.5C16.8284 18.5 17.5 17.8284 17.5 17V16ZM15.5 16C15.5 15.7239 15.7239 15.5 16 15.5C16.2761 15.5 16.5 15.7239 16.5 16V17C16.5 17.2761 16.2761 17.5 16 17.5C15.7239 17.5 15.5 17.2761 15.5 17V16Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5ZM15 11.5C15.2761 11.5 15.5 11.7239 15.5 12C15.5 12.2761 15.2761 12.5 15 12.5C14.7239 12.5 14.5 12.2761 14.5 12C14.5 11.7239 14.7239 11.5 15 11.5Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5 13.5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5C4.17157 10.5 3.5 11.1716 3.5 12C3.5 12.8284 4.17157 13.5 5 13.5ZM5 11.5C5.27614 11.5 5.5 11.7239 5.5 12C5.5 12.2761 5.27614 12.5 5 12.5C4.72386 12.5 4.5 12.2761 4.5 12C4.5 11.7239 4.72386 11.5 5 11.5Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6476 4.5H7.35208C6.66122 4.5 6.05972 4.97186 5.89522 5.64284L5.4049 7.64284C5.37625 7.75973 5.36176 7.87965 5.36176 8C5.36176 8.82843 6.03334 9.5 6.86176 9.5H13.1379C13.2582 9.5 13.3782 9.48552 13.495 9.45686C14.2996 9.2596 14.792 8.44744 14.5947 7.64284L14.1044 5.64284C13.9399 4.97186 13.3384 4.5 12.6476 4.5ZM6.86646 5.88095C6.92129 5.65729 7.12179 5.5 7.35208 5.5H12.6476C12.8779 5.5 13.0784 5.65729 13.1332 5.88095L13.6235 7.88095C13.6893 8.14915 13.5251 8.41987 13.2569 8.48562C13.218 8.49517 13.178 8.5 13.1379 8.5H6.86176C6.58562 8.5 6.36176 8.27614 6.36176 8C6.36176 7.95988 6.36659 7.91991 6.37614 7.88095L6.86646 5.88095Z" fill="currentColor" /></svg>
                    <span>{props.t("Parking ")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/parking_layouts_setup">
                        {props.t("Property Parking Layout Setup")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/assign_parking">
                        {props.t("Assign Parking")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="database" />
                    <span>{props.t("Storage ")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/storage_layouts_setup">
                        {props.t("Property Storage Layout Setup")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/assign_storage">
                        {props.t("Assign Storage")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="edit" />
                    <span>{props.t("Resident Applications")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/resident_application">
                        {props.t("Resident Applications")}
                        {dashboarddata.residentApplications
                          ? ` ( ${dashboarddata.residentApplications} Pending )`
                          : null}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/master_table">
                    <FeatherIcon icon="edit" />
                    <span> {props.t("Master sheet")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Inventory")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/inventory/create">
                        {props.t("Add Inventory")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/inventory/vendors">
                        {props.t("Add Vendor")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/inventory/orderlist">
                        {props.t("Order List")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/inventory/pastorders">
                        {props.t("Past Order")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/inventory/consumeditems">
                        {props.t("Consumed Items")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/inventory">
                        {props.t("General Inventory")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/inventory/appliances">
                        {props.t("Appliances")}
                      </Link>
                    </li> */}
                  </ul>
                </li>

                {/* <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="trending-up" />
                    <span>Inspection Report</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/inspection-reports/common-area">
                        Common Area Inspections
                      </Link>
                    </li>
                    <li>
                      <Link to="/inspection-reports/view-inspections">
                        View Inspections
                      </Link>
                    </li>
                  </ul>
                </li> */}

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Report Card")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/reportcard/list">{props.t("Overview")}</Link>
                    </li>
                    <li>
                      <Link to="/reportcard/employee">
                        {props.t("CS Report Card")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/reportcard/communityleader">
                        {props.t("CL REport Card")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/reportcard/rnmpersonal">
                        {props.t("R&M Report Card")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="settings" />
                    <span>{props.t("KPI Report")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/kpi-report">{props.t("KPI Report")}</Link>
                    </li>
                  </ul>
                </li>
                <li className="facilities-li">
                  <Link to="/widget">
                    <FeatherIcon icon="settings" />
                    <span> {props.t("Widget Settings")}</span>
                  </Link>
                </li>

                <li className="facilities-li">
                  <a
                    target="_blank"
                    href="http://sms.rentdigicare.com"
                    className=""
                    rel="noreferrer"
                  >
                    <FeatherIcon icon="message-square" />
                    <span>{props.t(`${user} SMS`)}</span>
                  </a>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "manager") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/dashboard" className="">
                    <FeatherIcon icon="grid" />
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li className="facilities-li">
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="home" />
                    <span>{props.t("Properties")}</span>
                  </Link>
                  {/* <ul className="sub-menu">
                    <li>
                      <Link to="/property">{props.t("Property")}</Link>
                    </li>
                    <li className="tanent_Information">
                      <Link to="/parking_info">{props.t("Parking")}</Link>
                    </li>
                    <li>
                      <Link to="/storage_info">{props.t("Storage")}</Link>
                    </li>
                  </ul> */}
                </li>
                {decode.calendarPrivilege && (
                  <li>
                    <Link to="/#" className="has-arrow ">
                      <FeatherIcon icon="calendar" />
                      <span>{props.t("Calendar")}</span>
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/apps-calendar">
                          {props.t("Calendar View")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/calender_availabilty">
                          {props.t("Availability")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/appointments">
                          {props.t("Appointments")}
                          <br />
                          {appointmentsInfo &&
                            appointmentsInfo.pending !== null &&
                            appointmentsInfo.pending !== undefined &&
                            appointmentsInfo.pending !== 0
                            ? `${appointmentsInfo.pending} Pending`
                            : `0 Pending`}
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
                {decode.ticketPrivilege && (
                  <>
                    <li>
                      <Link to="/#" className="has-arrow ">
                        <FeatherIcon icon="file-text" />
                        <span>{props.t("Maintenance Request")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/tickets_list">
                            {props.t("View Request")}
                            <br />
                            {maintenanceRequestInfo &&
                              maintenanceRequestInfo.open !== undefined &&
                              `${maintenanceRequestInfo.open.count} Open`}
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </>
                )}
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="monitor" />
                    <span>{props.t("Maintenance Team")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/technical_staff">
                        {props.t("View Maintenance Team")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="users" />
                    <span>{props.t("Vendors")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/viewvendor">{props.t("View Vendors")}</Link>
                    </li>
                  </ul>
                </li>
                {decode.applicationPrivilege && (
                  <li>
                    <Link to="/#" className="has-arrow ">
                      <FeatherIcon icon="edit" />
                      <span>{props.t("Resident Applications")}</span>
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/resident_application">
                          {`${props.t("Resident Applications")}`}
                          <br />
                          {`${residentApplicationInfo &&
                            `${residentApplicationInfo.Pending} Pending`
                            }`}
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="briefcase" />
                    <span>{props.t("Leads")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/viewleads">
                        {props.t("View Leads")}
                        <br />
                        {`${viewLeadsInfo && `${viewLeadsInfo.pending} Pending`
                          }`}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.2"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.27323 4.00237C6.54965 4.17438 5.98127 4.73371 5.79768 5.45445L4.60127 10.1512C3.68774 10.336 3 11.1434 3 12.1115V15C3 15.8061 3.4769 16.5008 4.16395 16.8174C4.05913 17.0222 4 17.2542 4 17.5V18.5C4 19.3284 4.67157 20 5.5 20C6.32843 20 7 19.3284 7 18.5V17.5C7 17.3247 6.96992 17.1564 6.91465 17H16.0854C16.0301 17.1564 16 17.3247 16 17.5V18.5C16 19.3284 16.6716 20 17.5 20C18.3284 20 19 19.3284 19 18.5V17.5C19 17.2542 18.9409 17.0222 18.836 16.8174C19.5231 16.5008 20 15.8061 20 15V12.1115C20 11.1434 19.3123 10.336 18.3987 10.1512L17.2023 5.45433C17.0187 4.73367 16.4504 4.17437 15.7269 4.00229C14.3193 3.66752 12.9103 3.5 11.5007 3.5C10.0911 3.5 8.68164 3.66755 7.27323 4.00237Z" fill="currentColor" /></g><path fill-rule="evenodd" clip-rule="evenodd" d="M4.29768 3.95445L3.10127 8.65122C2.18774 8.83604 1.5 9.64344 1.5 10.6115V13.5C1.5 14.6046 2.39543 15.5 3.5 15.5L16.5 15.5C17.6046 15.5 18.5 14.6046 18.5 13.5V10.6115C18.5 9.64344 17.8123 8.83604 16.8987 8.65122L15.7023 3.95433C15.5187 3.23367 14.9504 2.67437 14.2269 2.50229C12.8193 2.16752 11.4103 2 10.0007 2C8.59105 2 7.18164 2.16755 5.77323 2.50237C5.04965 2.67438 4.48127 3.23371 4.29768 3.95445ZM3.5 9.61147C3.72861 9.61147 3.9281 9.45643 3.98453 9.2349L5.26673 4.2013C5.35853 3.84093 5.64272 3.56126 6.00452 3.47525C7.33767 3.15832 8.66949 3 10.0007 3C11.3318 3 12.6632 3.15829 13.9955 3.47515C14.3573 3.56119 14.6414 3.84085 14.7332 4.20118L16.0155 9.2349C16.0719 9.45643 16.2714 9.61147 16.5 9.61147C17.0523 9.61147 17.5 10.0592 17.5 10.6115V13.5C17.5 14.0523 17.0523 14.5 16.5 14.5H3.5C2.94772 14.5 2.5 14.0523 2.5 13.5V10.6115C2.5 10.0592 2.94772 9.61147 3.5 9.61147Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 16C5.5 15.1716 4.82843 14.5 4 14.5C3.17157 14.5 2.5 15.1716 2.5 16V17C2.5 17.8284 3.17157 18.5 4 18.5C4.82843 18.5 5.5 17.8284 5.5 17V16ZM3.5 16C3.5 15.7239 3.72386 15.5 4 15.5C4.27614 15.5 4.5 15.7239 4.5 16V17C4.5 17.2761 4.27614 17.5 4 17.5C3.72386 17.5 3.5 17.2761 3.5 17V16Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16V17C14.5 17.8284 15.1716 18.5 16 18.5C16.8284 18.5 17.5 17.8284 17.5 17V16ZM15.5 16C15.5 15.7239 15.7239 15.5 16 15.5C16.2761 15.5 16.5 15.7239 16.5 16V17C16.5 17.2761 16.2761 17.5 16 17.5C15.7239 17.5 15.5 17.2761 15.5 17V16Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5ZM15 11.5C15.2761 11.5 15.5 11.7239 15.5 12C15.5 12.2761 15.2761 12.5 15 12.5C14.7239 12.5 14.5 12.2761 14.5 12C14.5 11.7239 14.7239 11.5 15 11.5Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5 13.5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5C4.17157 10.5 3.5 11.1716 3.5 12C3.5 12.8284 4.17157 13.5 5 13.5ZM5 11.5C5.27614 11.5 5.5 11.7239 5.5 12C5.5 12.2761 5.27614 12.5 5 12.5C4.72386 12.5 4.5 12.2761 4.5 12C4.5 11.7239 4.72386 11.5 5 11.5Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6476 4.5H7.35208C6.66122 4.5 6.05972 4.97186 5.89522 5.64284L5.4049 7.64284C5.37625 7.75973 5.36176 7.87965 5.36176 8C5.36176 8.82843 6.03334 9.5 6.86176 9.5H13.1379C13.2582 9.5 13.3782 9.48552 13.495 9.45686C14.2996 9.2596 14.792 8.44744 14.5947 7.64284L14.1044 5.64284C13.9399 4.97186 13.3384 4.5 12.6476 4.5ZM6.86646 5.88095C6.92129 5.65729 7.12179 5.5 7.35208 5.5H12.6476C12.8779 5.5 13.0784 5.65729 13.1332 5.88095L13.6235 7.88095C13.6893 8.14915 13.5251 8.41987 13.2569 8.48562C13.218 8.49517 13.178 8.5 13.1379 8.5H6.86176C6.58562 8.5 6.36176 8.27614 6.36176 8C6.36176 7.95988 6.36659 7.91991 6.37614 7.88095L6.86646 5.88095Z" fill="currentColor" /></svg>
                    <span>{props.t("Parking ")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/assign_parking">
                        {props.t("Assign Parking")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="database" />
                    <span>{props.t("Storage ")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/assign_storage">
                        {props.t("Assign Storage")}
                      </Link>
                    </li>
                  </ul>
                </li>
                {decode.masterSheetPrivilege && (
                  <li>
                    <Link to="/master_table">
                      <FeatherIcon icon="settings" />
                      <span> {props.t("Master sheet")}</span>
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="/kpi-report">
                    <FeatherIcon icon="settings" />
                    <span> {props.t("KPI Report")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "customer") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Maintenance Request")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/ticket_manager">
                        {props.t("Create Request")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/tickets_list">{props.t("View Requests")}</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "vendor") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Maintenance Request")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/working-tickets">
                        {props.t("Working Request")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "technical staff") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="file-text" />
                    <span>{props.t("Maintenance Request")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/technical_staff_tickets">
                        {props.t("View Maintenance Request")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "technical staff") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/#" className="has-arrow ">
                    <FeatherIcon icon="share-2" />
                    <span>{props.t("Maintenance Request")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/technical_staff_tickets">
                        {props.t("View Request")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else if (role === "accountant") {
      return (
        <React.Fragment>
          <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
            <div id="sidebar-menu">
              <ul
                className={` list-unstyled metismenu-${props.companyClass}`}
                id="side-menu"
              >
                <li>
                  <Link to="/kpi-report">
                    <FeatherIcon icon="settings" />
                    <span> {props.t("KPI Report")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/UploadKpi">
                    <FeatherIcon icon="briefcase" />
                    <span> {props.t("UploadKpi")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </SimpleBar>
        </React.Fragment>
      );
    } else {
      return <h1>last one</h1>;
    }
  } else {
    window.location.replace("/login");
  }
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
